module.exports = __webpack_public_path__ + "img/procedure-banner.a67b0b8d.jpg";